export const CRM_SUITE_PRODUCT_API_NAMES_BY_SKU_CATEGORY_NAME = {
  CRM_SUITE: ['crm-suite-free-bundle', 'crm-suite-starter-bundle', 'crm-suite-professional-bundle', 'crm-suite-enterprise-bundle']
};
export const NON_SUITE_PRODUCT_API_NAMES_BY_SKU_CATEGORY_NAME = {
  MARKETING_PRODUCTS: ['marketing-hub-free', 'marketing-hub-starter', 'marketing-hub-professional', 'marketing-hub-enterprise'],
  SALES_PRODUCTS: ['sales-hub-free', 'sales-hub-starter', 'sales-hub-professional', 'sales-hub-enterprise'],
  SERVICE_HUB_PRODUCTS: ['service-hub-free', 'service-hub-starter', 'service-hub-professional', 'service-hub-enterprise'],
  COMMERCE_PRODUCTS: ['commerce-hub-free', 'commerce-hub-professional', 'commerce-hub-enterprise'],
  CMS_HUB_PRODUCTS: ['cms-hub-free', 'cms-hub-starter', 'cms-hub-professional', 'cms-hub-enterprise'],
  OPERATIONS_HUB_PRODUCTS: ['operations-hub-starter', 'operations-hub-professional', 'operations-hub-enterprise']
};